import Api from "../../../axios";
import { callLoader } from "../../../common/actions/app";

let ACTION_DASHBOARD_VIEW = {
    type: 'DASHBOARD_VIEW',
    payload: {
        regions: [],
        dateCheck: ''
    },
};

let callDashboardViewGet = (loader = true) => (dispatch) => {
    if (loader) {
        dispatch(callLoader(loader))
    }
    Api.get('/dashboard').then((data) => {
        if (loader) {
            dispatch(callLoader(false))
        }
        if (!data)
            return

        ACTION_DASHBOARD_VIEW.payload.regions = data.regions
        ACTION_DASHBOARD_VIEW.payload.dateCheck = data.dateCheck
        dispatch(ACTION_DASHBOARD_VIEW)
    })
}


export { callDashboardViewGet, ACTION_DASHBOARD_VIEW }